import styled from '@emotion/styled';

export const StyledCard = styled.div`
  width: 100%;

  .mui-card-border-hover {
    :hover {
      border: 1px solid ${({ theme }) => theme.palette?.grey?.[300]};
      box-shadow: 2px 4px 6px 4px #0000001A !important;
    }
  }  
`;
